import Typography from "@mui/material/Typography";
import OnboardingForm from "../../OnboardingForm";
import { FormField, type OnboardingUploadDocumentsProps } from "./types";
import DocumentFileInput from "./DocumentFileInput";
import { acceptRules, IdentityWithExcelPlaceholderTitle } from "ui/forms/formik-elements/FileInput";

const UploadDocuments = (props: OnboardingUploadDocumentsProps) => {
    const {
        values,
        isSubmitting,
        isValid,
        isBootstrapDataLoading,
        isIncomplete,
        requestedChangeFields,
        bootstrapData,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit,
        ...form
    } = props;

    return (
        <OnboardingForm
            {...form}
            isSubmitting={isSubmitting}
            isValid={isValid}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            handleSubmit={handleSubmit}
        >
            <Typography
                variant='h6'
            >
                Certificate of Incorporation
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.CertificateOfIncorporation
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Memorandum and Articles of Association
            </Typography>
            <Typography
                variant='caption'
            >
                (or official document that shows shareholders with percentage of shares)
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.MemorandumAndArticles
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Company Account Bank Statement
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.CompanyAccountBankStatement
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Company Financial Statement
            </Typography>
            <Typography
                variant='caption'
            >
                Previous fiscal year
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.CompanyFinancialStatement,
                        accept: acceptRules.identityWithExcel,
                        placeholderProps: {
                            titleSlot: (
                                <IdentityWithExcelPlaceholderTitle />
                            )
                        }
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Bank Reference
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.BankReference
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Copy of your license(s)
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: true,
                        name: FormField.CopyOfLicences
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Proof of Domain Ownership
            </Typography>
            <Typography
                variant='caption'
            >
                A monthly or yearly invoice or screenshot clearly showing ownership of each domain you wish to onboard
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: true,
                        name: FormField.ProofOfDomainOwnership
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Official Company Documents filed with the authorities confirming latest Directorship and Shareholding of the company
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: false,
                        name: FormField.OfficialCompanyDocWithAuthority
                    }
                }}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                Company structure chart / diagram
            </Typography>
            <Typography
                variant='caption'
            >
                Where the structure of the company involves three or more companies, please provide clear chart/diagram along with the same documents, as stated above, for each company and shareholder involved in the structure.
            </Typography>
            <DocumentFileInput
                {...props}
                slotProps={{
                    proofFileInput: {
                        multiple: true,
                        name: FormField.StructureChart
                    }
                }}
            />
        </OnboardingForm>
    );
};

export default UploadDocuments;
